/* eslint-disable camelcase */
const getTopLevelNavItems = routes => {
  let topLevelNavItems = [];
  routes.forEach(route => {
    topLevelNavItems.push({
      name: route.name,
      link: route.link,
      order: route.order,
      order_mobile: route.order_mobile || route.order,
      children: route.children || []
    });
  });
  return topLevelNavItems;
};

export { getTopLevelNavItems };
